import {
  isKeyFromEditableField,
  isKeyFromNestedPopup,
} from '@mangovoice/mango-ui'

const OPEN_LAYER_SELECTOR = [
  '[role="dialog"][data-state="open"]',
  '[role="alertdialog"][data-state="open"]',
  '[data-scope="tooltip"][data-part="content"][data-state="open"]',
].join(', ')

/**
 * Whether a window-level Escape listener for a side panel (call details,
 * user details) should close the panel. Escape belongs to the innermost
 * widget first: an already-handled event, a nested menu/listbox, a field
 * being edited, or an open dialog/tooltip keep the panel open.
 */
export const shouldPanelHandleEscape = (event: KeyboardEvent): boolean =>
  event.key === 'Escape' &&
  !event.defaultPrevented &&
  !isKeyFromNestedPopup(event) &&
  !isKeyFromEditableField(event) &&
  document.querySelector(OPEN_LAYER_SELECTOR) === null
